import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import ReactCountryFlag from "react-country-flag";
import { DEFAULT_LANG } from "../../i18n"

// @ts-ignore
import "./LanguageSelector.scss";

const LANGUAGES = [
  { 
    text: "Polski",
     value: "pl",
     flag: "PL" 
  },
  { 
    text: "English", 
    value: "en", 
    flag: "GB" 
  },
];

type Props = {
   onClose: () => void;
};

const LanguageSelector = ({ onClose }: Props) => {
  const { i18n } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);

  const changeLanguage = (value: string) => {
    localStorage.setItem("lang", value);
    i18n.changeLanguage(value);
  };

  useEffect(() => {
    const langs = LANGUAGES.map(lang => lang.value);
    if (!langs.includes(i18n.language)) i18n.changeLanguage(DEFAULT_LANG);
  }, [i18n.language]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) onClose();
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div ref={ref} className="language-selector">
      <ul>
        {LANGUAGES.map(item => (
          <li key={item.value} onClick={() => changeLanguage(item.value)}>
            <ReactCountryFlag countryCode={item.flag} svg style={{ fontSize: "1.5rem", marginRight: 8 }} />
            {item.text}
            {i18n.language === item.value && (<i aria-hidden="true" className="v-icon material-icons">chevron_left</i>)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LanguageSelector;